module.exports = __webpack_public_path__ + "resources/img/logo_partner_web_kongdoo.c8d44e3f54544bb7d8e6bbf4981cfea9.png";